/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneHamburger from 'base/components/standalone/Hamburger';

export const DynamicStandaloneHamburger = StandaloneHamburger;
export type DynamicStandaloneHamburgerProps = PropsFromComponent<typeof StandaloneHamburger>;

export const DynamicStandaloneHamburgerWith = (extras: DynamicStandaloneExtras): typeof StandaloneHamburger => {
    return function DynamicStandaloneHamburger(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Hamburger');
        return <StandaloneHamburger {...mergeProps({ options: { theme } }, props)} />;
    }
}